<template>
  <div>
    <template v-if="loading">
      <div
        class="d-flex vertical-center justify-content-center align-items-center"
        style="height: 50vh; dislay: flex"
      >
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <CModal
        title="Test has been closed."
        centered
        color="light"
        :show.sync="adminLockTestModal"
        :closeOnBackdrop="false"
      >
        <h5>Contact the instructor of your section and try again later.</h5>
        <br />
      </CModal>
      <CModal
        title="Post-test has been closed."
        centered
        color="light"
        :show.sync="adminLockPostTestModal"
        :closeOnBackdrop="false"
      >
        <h5>{{ detail_posttest }}</h5>
        <br />
      </CModal>
      <full-page :options="options" id="fulp" ref="fullpage">
        <div class="section">
          <div class="body-slide">
            <SwiperItem
              :items="content"
              :lang="lang"
              :subProgress ="subProgress"
              @nextRoute="nextRoute"
              :allContent="allContent"
              :lessonActive="lessonActive"
            />
          </div>
        </div>
        <div class="section text-center">
          <div class="body-slide">
            <List
              :items="content"
              :lang="lang"
              @nextRoute="nextRouteList"
              :allContent="allContent"
            />
          </div>
        </div>
      </full-page>
    </template>
  </div>
</template>

<script>
import FullPage from "vue-fullpage.js/src/FullPage.vue";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import SwiperItem from "@/components/elements/SwiperItem";
import List from "@/components/elements/List_Menu/List";
import { mapGetters } from "vuex";
import LoadingMDL from "@/components/loading/LoadingMDL";

export default {
  name: "LS01",
  components: { FullPage, Swiper, SwiperSlide, SwiperItem, List, LoadingMDL },
  data() {
    return {
      options: {
        navigation: true,
        navigationPosition: "right",
        sectionsColor: ["#E6EFFF", "#E6EFFF"],
      },
      loading: true,
      currentRoute: "",
      content: [],
      lang: "",
      allContent: [],
      lessonActive: null,
      adminLockTestModal: false,
      adminLockPostTestModal: false,
      detail_posttest: "",
      code:"",
      section:"",
      subProgress : []
    };
  },
  methods: {
    nextRoute: function (path) {
      if (path != "" && typeof path != "object") {
        let str = path.split("-");
        let body = "/" + str[0] + "/" + str[1];
        this.$router.push(body);
      } else if (typeof path == "object") {
        if (path.lock) {
          this.adminLockTestModal = true;
        } else {
          let str = path.path.split("-");
          let body = "/" + str[0] + "/" + str[1];
          this.$router.push(body);
        }
      }
    },
    nextRouteList: function (path) {
      if (path != null) {
        if (parseInt(path) == 0) {
          this.$router.push("/LS04/1");
        } else if (parseInt(path) == 1) {
          this.$router.push("/CLP01/1");
        } else if (typeof path == "object") {
          if (path.lock) {
            this.adminLockPostTestModal = true;
            this.detail_posttest = path.detail;
          } else if (path.lock == false) {
            this.$router.push("/CMD01/90");
          } else {
            this.adminLockPostTestModal = true;
            this.detail_posttest = path.detail;
          }
        }
      }
    },
  },
  computed: {
    ...mapGetters({
      storeLanguage: "language/getLanguage",
      getLessonAndProgress: "template/getLessonAndProgress",
    }),
  },
  watch: {
    getLessonAndProgress: function (data) {
      // console.log('>>>>>',data);
      this.content = data.templateData.content.item;
      this.subProgress = data.menuSubProgress
      this.allContent = data;
      this.loading = false;
      this.$store.commit("necessary/setMenuLockChinese2", data.menuLock);

      console.log('weasdsad', this.content)
      console.log('weasdsad', this.subProgress)
      console.log('weasdsad', this.allContent)
      console.log('xxxxxx', data.menuLock)
    },
    storeLanguage: function (val) {
      this.lang = val;
    },
  },
  created() {
    this.lang = this.$store.getters["language/getLanguage"];
    this.lessonActive = this.$store.getters["necessary/getLessonActive"];
    this.currentRoute = this.$route.name + "-" + this.$route.params.id;
    this.courseData = this.$store.getters["necessary/getLerningCourse"]
    this.code = this.courseData._id;
    this.section = this.$store.getters['necessary/getUserCourseSection']
    console.log('zzzzzzzzzzzzzzzzzzz',this.section);
  },
  mounted() {
    let payload = {
      templateCode: this.currentRoute,
      code:this.code,
      section:this.section
    };
    console.log(payload.section);
    this.$store.dispatch("template/fetchLessonAndProgress", payload);
  },
};
</script>

<style>
@import "https://unpkg.com/fullpage.js/dist/fullpage.min.css";
* {
  user-select: none;
}
.modal-title {
  color: white;
}
.modal-light .modal-header {
  background-color: #808588;
}
.btn-light,
.btn-light:hover {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}

.btn-secondary,
.btn-secondary:hover {
  color: #212529;
  background-color: #e2e6ea;
  border-color: #dae0e5;
}

.body-slide {
  display: flex;
  margin-top: 14%;
  width: 100%;
  justify-content: center;
}
#fp-nav ul,
.fp-slidesNav ul {
  margin: 0;
  padding: 0;
  display: flex;
  height: 80vh;
  flex-direction: column;
  justify-content: space-around;
  background-color: #89abe6;
  border-radius: 20px;
  width: 6px;
  align-items: center;
}

#fp-nav:hover ul li a span,
.fp-slidesNav ul li a span {
  margin: -2px 0 0 -2px;
  width: 15px;
  height: 15px;
}

#fp-nav ul li a.active span,
#fp-nav ul li:hover a.active span,
.fp-slidesNav ul li a.active span,
.fp-slidesNav ul li:hover a.active span {
  height: 20px;
  width: 20px;
  margin: -6px 0 0 -6px;
  border-radius: 100%;
  position: absolute;
  left: 30%;
  background-color: #1d5bd7;
}

#fp-nav ul li a span,
.fp-slidesNav ul li a span {
  border-radius: 50%;
  position: absolute;
  z-index: 1;
  height: 15px;
  width: 15px;
  border: 0;
  background: #89abe6;
  left: 10%;
  /* top: 50%; */
  margin: -2px 0 0 -2px;
  -webkit-transition: all 0.1s ease-in-out;
  -moz-transition: all 0.1s ease-in-out;
  -o-transition: all 0.1s ease-in-out;
  transition: all 0.1s ease-in-out;
}

@media only screen and (min-width: 300px) and (max-width: 1024px) {
  #fp-nav ul,
  .fp-slidesNav ul {
    margin: 0;
    padding: 0;
    display: flex;
    height: 5vh;
    flex-direction: column;
    border-radius: 20px;
    width: 0;
  }
  #fp-nav ul li a.active span,
  #fp-nav ul li:hover a.active span,
  .fp-slidesNav ul li a.active span,
  .fp-slidesNav ul li:hover a.active span {
    height: 12px;
    width: 12px;
    margin: -6px 0 0 -6px;
    border-radius: 100%;
    position: absolute;
    left: 10%;
    background-color: #1d5bd7;
  }

  #fp-nav ul li a span,
  .fp-slidesNav ul li a span {
    border-radius: 50%;
    position: absolute;
    z-index: 1;
    height: 10px;
    width: 10px;
    border: 0;
    background: #89abe6;
    left: -10%;
    top: 50%;
    margin: -2px 0 0 -2px;
    -webkit-transition: all 0.1s ease-in-out;
    -moz-transition: all 0.1s ease-in-out;
    -o-transition: all 0.1s ease-in-out;
    transition: all 0.1s ease-in-out;
  }
  .card {
    border: 0;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 20%);
  }
}

@media only screen and (min-width: 1600px) {
  #fp-nav.fp-left {
    left: 17px;
    margin-left: 3%;
  }
}
</style>
